import React from 'react';
import TransactionInProgress from '@linkexchange/components/src/TransactionInProgress';

const PaymentInProgress = () => <TransactionInProgress>Payment in progress</TransactionInProgress>;

export default PaymentInProgress;
